module.exports = __webpack_public_path__ + "img/Apex-logo.9b434dd7.svg";